import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import ManualHeader from "../../layout/ManualHeader.js";
import "../../styles/ManualPage.css";

const ManualPage = () => {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch("/docs/Manual.md")
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
  }, []);

 return (
  <>
    <div className="manual_header-container">
      <ManualHeader />
    </div>
    <div className="manual-container">
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{
          br: () => <br />, // br 태그 명시적으로 허용
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  </>
);
};

export default ManualPage;
